import { cn } from '@/lib/utils';

interface LogoProps {
  readonly className?: string;
}

export function Logo({ className }: LogoProps) {
  return (
    <img
      alt="One Score logo"
      className={cn('rounded-full', 'object-cover', className)}
      src="/one-score.png"
    />
  );
}
